// File: src/pages/ApprovalManager/ApprovalManagerMissedPunch.js
/*
 * BRAND NEW FILE — Did not exist in original
 * -----------------------------------------------------------------------
 * API:
 *   GET  /api/missed-punch/approval-manager
 *   POST /api/missed-punch/approval-manager/approve/{id}?remarks=...
 *   POST /api/missed-punch/approval-manager/reject/{id}?remarks=...
 */
import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Typography, Paper, Table, TableHead, TableRow, TableCell,
  TableBody, Button, TextField, Stack, Chip, TableContainer,
  CircularProgress, Alert, Modal
} from '@mui/material';
import api from '../../api/axios';
import toast from 'react-hot-toast';

const MODAL_STYLE = {
  position: 'absolute', top: '50%', left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 420, bgcolor: 'background.paper',
  boxShadow: 24, p: 4, borderRadius: 3
};

const ApprovalManagerMissedPunch = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ open: false, id: null, approve: true, remark: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/missed-punch/approval-manager');
      setRequests(res.data || []);
    } catch (e) {
      toast.error('Failed to load missed punch requests');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openModal = (id, approve) =>
    setModal({ open: true, id, approve, remark: '' });

  const submit = async () => {
    if (!modal.remark.trim()) {
      toast.error('Remark is required');
      return;
    }
    try {
      const endpoint = modal.approve
        ? `/missed-punch/approval-manager/approve/${modal.id}`
        : `/missed-punch/approval-manager/reject/${modal.id}`;
      await api.post(`${endpoint}?remarks=${encodeURIComponent(modal.remark)}`);
      toast.success(modal.approve ? 'Approved (Final) — attendance corrected' : 'Rejected');
      setModal({ open: false, id: null, approve: true, remark: '' });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Action failed');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={800} mb={3}>
        Missed Punch Approvals — First Level
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : requests.length === 0 ? (
        <Alert severity="success" sx={{ borderRadius: 3 }}>No pending missed punch requests.</Alert>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f1f5f9' }}>
              <TableRow>
                <TableCell><b>Employee</b></TableCell>
                <TableCell><b>Date</b></TableCell>
                <TableCell><b>Punch Type</b></TableCell>
                <TableCell><b>Requested Clock In</b></TableCell>
                <TableCell><b>Requested Clock Out</b></TableCell>
                <TableCell><b>Reason</b></TableCell>
                <TableCell><b>Status</b></TableCell>
                <TableCell><b>Action</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.map(r => (
                <TableRow key={r.attendanceId || r.id} hover>
                  <TableCell><b>{r.employeeName || '-'}</b></TableCell>
                  <TableCell>{r.date || r.attendanceDate || '-'}</TableCell>
                  <TableCell>
                    <Chip label={r.punchType || '-'} size="small" variant="outlined" />
                  </TableCell>
                  <TableCell>{r.requestedClockIn || '-'}</TableCell>
                  <TableCell>{r.requestedClockOut || '-'}</TableCell>
                  <TableCell sx={{ maxWidth: 180 }}>
                    <Typography fontSize={13}>{r.reason || '-'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Chip label={r.status} color="warning" size="small" />
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      <Button size="small" variant="contained" color="success"
                        onClick={() => openModal(r.attendanceId || r.id, true)}>
                        Approve
                      </Button>
                      <Button size="small" variant="outlined" color="error"
                        onClick={() => openModal(r.attendanceId || r.id, false)}>
                        Reject
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Modal open={modal.open} onClose={() => setModal({ ...modal, open: false })}>
        <Box sx={MODAL_STYLE}>
          <Typography variant="h6" fontWeight={700} mb={2}>
            {modal.approve ? '✅ Approve Missed Punch' : '❌ Reject Missed Punch'}
          </Typography>
          <TextField
            fullWidth multiline rows={3}
            label="Your Remark — Final Decision (visible to Cluster Manager in history) *"
            value={modal.remark}
            onChange={e => setModal({ ...modal, remark: e.target.value })}
            sx={{ mb: 2 }}
          />
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" fullWidth onClick={() => setModal({ ...modal, open: false })}>Cancel</Button>
            <Button variant="contained" fullWidth
              color={modal.approve ? 'success' : 'error'}
              disabled={!modal.remark.trim()}
              onClick={submit}
            >
              Confirm
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
};

export default ApprovalManagerMissedPunch;